import { render } from "./OrganisationUserGoodiesAdmin.vue?vue&type=template&id=65906940"
import script from "./OrganisationUserGoodiesAdmin.vue?vue&type=script&lang=js"
export * from "./OrganisationUserGoodiesAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__